// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"152":"base","332":"detail"}[chunkId] + "." + {"152":"a27c750c","332":"17f2ed8e"}[chunkId] + ".js";
};